<flo-video-player
  *ngIf="video$ | async as video"
  [video]="video"
  [isAutoPlayed]="false"
  [isEmbedded]="true"
></flo-video-player>
